/* eslint-disable react/forbid-prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import {slugifyUrl} from "../../helpers/filters";
import './DealerRankingsSidebar.scss';

class DealerRankingsSidebar extends Component {

    static propTypes = {
        dealers: PropTypes.array.isRequired,
    };

    state = {
        visible: true
    };

    componentWillMount = () => {
        this.sideMenuActivate();
    };

    componentDidMount = () => {
        window.addEventListener("resize", this.sideMenuActivate, false);
    };

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.sideMenuActivate, false);
    };

    sideMenuActivate = () => {
        if (window.matchMedia("(max-width: 640px)").matches) {
            this.setState({visible: false});
        } else {
            this.setState({visible: true});
        }
    };

    render() {
        return (
            <aside className="dealerRankings__sidebar">
                <button type="button" aria-label="Use the dropdown menu to navigate to a different page" aria-haspopup="true" aria-expanded="false" onClick={() => this.setState({visible: !this.state.visible})}>Dealer Rankings <i className="fas fa-caret-down" aria-hidden="true" /></button>
                <ul className={this.state.visible ? 'sidebar__menu sidebar__menu--visible' : 'sidebar__menu'}>

                    {this.props.dealers.map((dealer) => (
                        <li className="sidebar__group" key={`tab_${dealer.label}`}>
                            <h3>{dealer.label}</h3>
                            <ul>
                                {dealer.links.map(item => (
                                    <li key={`sidebargroup__${slugifyUrl(dealer.label)}__${slugifyUrl(item.label)}`}>
                                        <NavLink activeClassName="active"
                                                 to={item.url.path}>
                                            {item.label}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </li>

                    ))}

                </ul>
            </aside>
        );
    }
}

export default DealerRankingsSidebar;



// WEBPACK FOOTER //
// ./frontend/pages/DealerRankings/DealerRankingsSidebar.jsx